export const MICROSOFT_APPS_URL = 'https://view.officeapps.live.com/op/embed.aspx?src='

export const getMicrosoftFileUrl = (fileUrl: string) => {
  return MICROSOFT_APPS_URL + fileUrl
}

export const getClearMicrosoftFileUrl = (url: string) => {
  if (url && url.indexOf(MICROSOFT_APPS_URL) > -1) {
    return url.replace(MICROSOFT_APPS_URL, '')
  }
  return url || ''
}

export const MICROSOFT_APPS_EXTENSIONS = ['pptx', 'ppt', 'xlsx', 'xls', 'doc', 'docx']
